import {
  ElitePrimeStrategyStatus,
  type ElitePrimeStrategyData
} from '../../../../types/elitePrimeSummary.types'
import type { AdviceCardStat } from '../../types/adviceCards.types'

export function isStrategyFindCopyStatus(status?: ElitePrimeStrategyData['status']): boolean {
  const resolvedStatus = status ?? ElitePrimeStrategyStatus.QUESTIONNAIRE_NOT_INITIATED
  return (
    resolvedStatus === ElitePrimeStrategyStatus.QUESTIONNAIRE_NOT_INITIATED ||
    resolvedStatus === ElitePrimeStrategyStatus.QUESTIONNAIRE_IN_PROGRESS
  )
}

export function isStrategyQuestionnaireSubmittedStatus(
  status?: ElitePrimeStrategyData['status']
): boolean {
  return (
    status === ElitePrimeStrategyStatus.QUESTIONNAIRE_SUBMITTED ||
    status === ElitePrimeStrategyStatus.QUESTIONNAIRE_RE_SUBMITTED
  )
}

function calendarDaysTillTimestamp(timestamp: number): number {
  const now = new Date()
  const target = new Date(timestamp)
  now.setHours(0, 0, 0, 0)
  target.setHours(0, 0, 0, 0)
  return Math.round((target.getTime() - now.getTime()) / (24 * 60 * 60 * 1000))
}

function remainingDaysText(epochMs: number): string {
  const days = calendarDaysTillTimestamp(epochMs)
  if (days <= 0) {
    return 'today'
  }
  if (days === 1) {
    return '1 day'
  }
  return `${days} days`
}

export function buildStrategyUnderReviewStats({
  planLabel,
  planAvailableAt,
  planAvailableInDays
}: {
  planLabel: string
  planAvailableAt?: number
  planAvailableInDays?: number
}): AdviceCardStat[] {
  const stats: AdviceCardStat[] = [{ label: 'Portfolio under review.', emphasize: true }]

  if ((planAvailableAt ?? 0) > Date.now()) {
    stats.push({
      label: `${planLabel} available in ${remainingDaysText(planAvailableAt ?? 0)}.`,
      emphasize: true
    })
    return stats
  }

  if ((planAvailableInDays ?? 0) > 0) {
    const days = planAvailableInDays ?? 0
    const daysLabel = days === 1 ? '1 day' : `${days} days`
    stats.push({
      label: `${planLabel} available in ${daysLabel}.`,
      emphasize: true
    })
  }

  return stats
}

export function buildStrategyFindCopyDisplay(findCopy: string) {
  return {
    stats: [{ label: findCopy, emphasize: true }],
    insightTone: 'orange' as const
  }
}
